import { type HttpGet, buildQueryString } from '@/shared/infra/http'
import type { LoadNotificationPreferences, NotificationPreferences } from '@/shared/domain'

type NotificationPreferencesResponse = { preferences: NotificationPreferences }

export class SupabaseLoadNotificationPreferencesRepository {
  constructor(private readonly http: HttpGet) {}

  execute: LoadNotificationPreferences = async ({ orgId, orgType }) => {
    const query = buildQueryString({ orgId, orgType })
    const response = await this.http.get<NotificationPreferencesResponse>({
      url: `/users/notification-preferences${query}`,
    })
    return { preferences: response.preferences }
  }
}
